<template>
  <Modal v-bind="$attrs" v-on="$listeners" @closed="closed" :xIconDisabled="loading">
    <div class="overflow-hidden rounded">
      <div class="overflow-auto px-2">
        <div class="flex justify-between">
          <div class="font-bold title mb-2">
            メール内容を確認し、送信ボタンを押してください
          </div>
        </div>

        <WmsTextInput
          name="subject"
          caption="件名"
          v-model="subject"
        />

        <textarea
          :rows="30"
          class="border-gray-300 rounded w-full mt-3 text-xs"
          v-model="text"
        ></textarea>

        <div class="flex" v-if="!loading">
          <PrimaryButton text="キャンセル" @click="closed()" class="m-3 bg-blue-100 text-blue-700 w-full">
          </PrimaryButton>
          <PrimaryButton text="メール送信" @click="sendMail()" class="m-3 w-full">
            <Icon iconName="Mail" slot="before" class="h-4 w-4" />
          </PrimaryButton>
        </div>
        <div v-else class="text-lg font-bold text-center title animate-pulse">
          送信中...
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Icon from '@components/Icon.vue'
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import WmsTextInput from '@wmscomponents/WmsTextInput.vue'
import * as dialogs from '@libs/dialogs'
import * as backend from '@libs/backend'
import * as moment from 'moment'


export default {
  components: {
    Modal,
    PrimaryButton,
    WmsTextInput,
    Icon,
  },

  //
  props: ['open', 'name', 'to', 'isLimit', 'limitDate', 'user', 'userId', 'newGrad'],

  data() {
    return {
      // ローディング
      loading: false,
      // タイトル
      subject: '',
      // 内容
      text: ''
    }
  },

  computed: {
  },

  watch: {
    open() {
      if (this.open) {
        this.setText()
      }
    }
  },

  methods: {
    /**
     * 初期にリセット
     */
    closed() {
      this.text = ''
      this.loading = false
      this.$emit('close')
    },

    /**
     * メール内容設定
     */
    async setText() {
      this.subject = '【アポロ管財】適性検査受検のご案内'
      let msg1 = ''

      const common1 =
        '下記URLより、適性検査の受検をお願いいたします。\n'
        + '----------------------------------------------------------------\n'
        + '■【適性検査URL】\n'
        + 'https://vip.sakura-ri.jp/energizer/\n\n'
        + '■【パスワード】\n'
        + 'hope（半角・小文字）\n\n'
        + '■【顧客様コード】\n'
        + '4桁：9020 ／ 2桁：92\n\n'
        + '【受検手順】\n'
        + '1．上記URLにアクセスし、「hope」「9020」「92」を入力し「次へ進む」をクリック\n'
        + '2．個人情報保護方針の確認：「同意する」にチェックし、「次へ進む」\n'

      let msg2 = ''

      let msg3 =
        '7．過去の受検歴（この適性検査を受けた経験）の確認：該当のものを選択\n'
        + '8．その他の質問に回答：該当箇所をクリック\n\n'
        + '※所要時間は30分程度お時間をいただきます。\n'
        + '※必ずマウスを使用してして実施してください。\n'
        + '----------------------------------------------------------------\n'

      let limit = ''

      // 新卒
      if (this.newGrad) {
        msg1 = '一次選考にご参加いただき誠にありがとうございました。\n'

        // 期限有の場合
        if (this.isLimit == 'limit') {
          moment.locale('ja')
          limit = `お時間に余裕のある際にご対応くださいませ。\n【${moment(this.limitDate).format('M月D日(ddd)')}】までにご受検いただきますようお願い申し上げます。\n`
        }

        msg2 =
            '3．「名」「性別」「生年月日」を入力\n'
          + '4．受検区分：「採用」にチェック\n'
          + '5．応募企業名：「アポロ管財株式会社」と入力\n'
          + '6．今の所属：「学生」にチェック → 大学名・学部を入力\n'

        msg3 +=
            limit
          + 'お手数ではございますが、受検完了後にご一報いただけますと幸いです。\n\n'

      // 中途
      } else {
        msg1 = '面接の時間を頂きまして誠にありがとうございました。\n'

        msg2 =
            '★受診区分を選んでください → 「採用応募者」 →「 中途（転職）です」をクリック\n'
          + '3．「名」「性別」「生年月日」を入力\n'
          + '4．応募企業名：「アポロ管財株式会社」と入力\n'
          + '5．現在の勤務先名：現在働いている会社名または直近まで勤めていた会社名を入力\n'
          + '6．所属部署：なければ、記載なしで結構です\n'

        // 期限有の場合
        if (this.isLimit == 'limit') {
          let day = this.limitDate
          if (day === moment().format('YYYY-MM-DD')) {
            day = '本日中の'
          } else {
            moment.locale('ja')
            day = '【' + moment(this.limitDate).format('M月D日(ddd)') + '】までの'
          }
          limit = `面接時に申し上げましたが、${day}ご実施をお願いします。\n`
        }

        msg3 +=
            '【お願い】\nお手数ですが、適性検査が完了しましたら必ず完了報告のメールをご返信ください。\n\n'
          + limit
      }
      let t = this.name + ' 様\n\n本日はお忙しい中、'
      + msg1
      + common1
      + msg2
      + msg3
      + 'ご不明な点等がございましたら、お気軽にご連絡ください。\n'
      + '何卒よろしくお願いいたします。\n\n'
      + 'アポロ管財株式会社\n'
      +  this.user

      this.text = t
    },

    /**
     * メール送信
     */
    async sendMail() {
      const log = await dialogs.showConfirmDialog('送信しますか？', '送信します。よろしいですか？')
      if (log != 'YES') {
        return
      }
      this.loading = true
      const param = {
        to: this.to,
        text: this.text,
        subject: this.subject,
        newGrad: this.newGrad,
        interviewerId: this.userId,
        interviewer:  this.user,
        name: this.name
      }
      const res = await backend.postData('apiProxy/mailApi/interviewsMail', param)
      this.loading = false
      if (res.data && res.data.data == 'success') {
        await dialogs.showSuccessDialog('送信しました', '送信完了しました。本人にメールが届いたかご確認ください。')
        this.$emit('sentEnergizer')
        this.closed()
      } else {
        let err = ''
        if (res.data && res.data.data) {
          err = 'エラー詳細：' + res.data.data
        }

        await dialogs.showErrorDialog('送信失敗', err)
      }
    },
  }
}
</script>
<style scoped>
  .main-height {
    height: 85vh;
  }

  .title {
    color: #7b77b9;
  }

  /* 入力欄を自動調整 */
  textarea {
    field-sizing: content !important;
  }
</style>